var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3.64,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.454545,
    y: 0.454545,
    width: 39.0909,
    height: 39.0909,
    rx: 3.18182,
    stroke: "#616161",
    strokeWidth: 0.909091
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10731_25227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3086 10.895V14.0358C21.3086 14.3281 21.4247 14.6084 21.6314 14.815C21.838 15.0217 22.1183 15.1378 22.4106 15.1378H25.5679L21.3361 10.895H21.3086Z",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7627 19.6514H22.4879",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7627 22.1299H22.4879",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7627 24.6104H22.4879",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7627 19.6514V24.6105",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.626 19.7114V24.6099",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4883 19.6514V24.6105",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5917 24.8718V15.152H22.4234C22.1311 15.152 21.8508 15.0359 21.6441 14.8292C21.4375 14.6225 21.3214 14.3422 21.3214 14.05V10.9092H12.9184C12.6262 10.9092 12.3459 11.0253 12.1392 11.232C11.9325 11.4386 11.8164 11.7189 11.8164 12.0112V27.9906C11.8164 28.2828 11.9325 28.5632 12.1392 28.7698C12.3459 28.9765 12.6262 29.0926 12.9184 29.0926L22.7255 29.091",
    stroke: "#616161",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5165 27.5264V25.4546H23.2876V27.5264H21.8164L24.9021 30.6121L27.9877 27.5264H26.5165Z",
    stroke: "#616161",
    strokeWidth: 0.909091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10731_25227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(9.08984 9.09082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.1cfff1594847d5760c1b4eaab217fafa.svg";
export { ForwardRef as ReactComponent };